import { Box, Button, TextField, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
import { RootState, useSelector } from 'src/store';
import {
  editText,
  editFontWeight,
  editColor,
  editFontSize,
  editTextAlign,
  editFontFamily
} from 'src/store/modules/editText';

interface editTextProps {
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #dddddd'
  },
  fontBox: {
    width: '100%',
    height: '2.5rem',
    padding: '0 0.78rem',

    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #D9D9D9'
  },
  input: {
    height: '4.5rem',
    padding: '0.5rem',
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    border: '1px solid #dddddd'
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },

  bottomBtn: {
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    // margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer'
  }
}));

const EditText: FC<editTextProps> = ({ type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let text = useSelector((state: RootState) => state.editText.text);

  const handleText = e => {
    let newText = JSON.parse(JSON.stringify(text));
    newText[type][currentIndex] = e.target.value;
    dispatch(editText(newText));
  };

  return (
    <TextField
      className={classes.input}
      id="standard-multiline-flexible"
      multiline
      InputProps={{
        classes: {
          root: classes.inputRoot,
          input: classes.inputText
        },
        disableUnderline: true
      }}
      value={text?.[type]?.[currentIndex]}
      onChange={handleText}
    />
  );
};

export default EditText;
